import * as Yup from 'yup';
import { getLocalizedStrings } from '../misc';

const LoginShema = Yup.object().shape({
  email: Yup.string()
    .email(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { INVALID_EMAIL }
          }
        }
      } = getLocalizedStrings();

      return INVALID_EMAIL;
    })
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { EMAIL_REQUIRED }
          }
        }
      } = getLocalizedStrings();

      return EMAIL_REQUIRED;
    }),
  password: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_REQUIRED }
        }
      }
    } = getLocalizedStrings();

    return PASSWORD_REQUIRED;
  })
});

export default LoginShema;
